import { Button, Card, Select, Table } from 'antd';
import React, { useMemo, useState } from 'react';

import {
  CARD_BODY_STYLES,
  CARD_HEAD_STYLES,
  DUMMY_TICKET_CATEGORY_OPTIONS,
} from '../../constants';
import { AddOrEditModal } from './components/AddOrEditModal';
import { DetailModal } from './components/DetailModal';
import {
  DUMMY_SERVICE_OPTIONS,
  DUMMY_TICKET_CATEGORY_TABLE_DATASOURCE,
} from './constants';
import { getTicketCategoryTableColumns } from './helpers';
import styles from './index.module.scss';
import type { ModalType, TicketCategoryTableData } from './types';

export const TicketCategories = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState<ModalType>(undefined);
  const [ticketName, setTicketName] = useState<{
    label: string;
    value: string;
  }>();
  const [serviceName, setServiceName] = useState<{
    label: string;
    value: string;
  }>();

  // TODO: 不知道會不會改動
  const [currentTicketCategoryData, setCurrentTicketCategoryData] = useState<
    TicketCategoryTableData | undefined
  >(undefined);

  const closeModal = () => setShowModal(false);

  const handleModalOpen = (type: ModalType) => {
    setModalType(type);
    setShowModal(true);
  };

  const columns = useMemo(
    () =>
      getTicketCategoryTableColumns(
        setCurrentTicketCategoryData,
        handleModalOpen
      ),
    []
  );

  const displayTableData = useMemo(() => {
    // TODO: 假資料，記得改真實資料
    let data = DUMMY_TICKET_CATEGORY_TABLE_DATASOURCE;
    if (ticketName) {
      data = data.filter((item) => item.ticketName === ticketName.value);
    }
    if (serviceName) {
      data = data.filter((item) => item.service === serviceName.value);
    }
    return data;
  }, [serviceName, ticketName]);

  return (
    <>
      <div className={styles.container}>
        <Button
          className={styles.addCategoryButton}
          onClick={() => {
            setCurrentTicketCategoryData(undefined);
            handleModalOpen('add');
          }}
        >
          新增票券類別
        </Button>
        <div className={styles.filters}>
          <div className={styles.filter}>
            <p>票券：</p>
            <Select
              className={styles.selector}
              allowClear
              // TODO: 假資料，記得改真實資料
              options={DUMMY_TICKET_CATEGORY_OPTIONS}
              placeholder="請選擇票券名稱"
              onChange={(_, option) => {
                const selectedOption = Array.isArray(option)
                  ? option[0]
                  : option;
                setTicketName(selectedOption);
              }}
            />
          </div>
          <div className={styles.filter}>
            <p>服務：</p>
            <Select
              className={styles.selector}
              allowClear
              // TODO: 假資料，記得改真實資料
              options={DUMMY_SERVICE_OPTIONS}
              placeholder="請選擇服務"
              onChange={(_, option) => {
                const selectedOption = Array.isArray(option)
                  ? option[0]
                  : option;
                setServiceName(selectedOption);
              }}
            />
          </div>
        </div>
        <Card
          title="票券類別"
          headStyle={CARD_HEAD_STYLES}
          bodyStyle={CARD_BODY_STYLES}
        >
          <Table
            bordered
            rowKey="_id" // TODO: 看rowKey到時候有沒有變，有變再改
            scroll={{ x: 'max-content' }}
            columns={columns}
            dataSource={displayTableData}
          />
        </Card>
      </div>
      {!modalType ? null : modalType === 'view' ? (
        <DetailModal
          showModal={showModal}
          closeModal={closeModal}
          ticketCategoryData={currentTicketCategoryData}
        />
      ) : (
        <AddOrEditModal
          showModal={showModal}
          modalType={modalType}
          closeModal={closeModal}
          editingData={currentTicketCategoryData}
        />
      )}
    </>
  );
};
